import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ViewChild, ElementRef } from '@angular/core';
import { CategoryService } from '../category.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-motherspage',
  templateUrl: './motherspage.component.html',
  styleUrl: './motherspage.component.css'
})
export class MotherspageComponent {
  textInput: string = '';
  openSection: string = '';
  documentFile: File | null = null;
  noOptionField: string = '';
  profileData: any;
  defaultCategoryId: number = 0;
  categoryId: any;
  voucherCategories: any[] = [];
  isUploading: boolean = false;


  currentStep: string | null = null;
  mobileVerified: boolean = false;
  firmDetailsValid: boolean = false;
  mobileNumber: any = '';
  firm_name: any = '';
  refName: any = '';
  state: any = '';
  city: any = '';

  statesAndCities: any[] = [];
  dropdownoptionState: any = '';
  dropdownoptionCity: any = '';
  selectedState: any = '';
  selectedCity: any = '';
  cities: any[] = [];

  // currentStep: string | null = null;

  token : any = '609615431cd8d539b733876c7e0c511dSAGLcHZ6nxEBnE4XlJ1nmcPTZaOXOGIXW';

  constructor(private http: HttpClient,
    private categoryService: CategoryService,
    private route: ActivatedRoute,
    private router: Router,
    private scroller: ViewportScroller,
    private fb: FormBuilder
  ) {}

  ngOnInit() : void{
    window.scrollTo(0, 0);
    this.profileData = localStorage.getItem('profileData');

    this.getStatesAndCities();

    // fetch categories
    this.fetchVoucherCategories();
    this.route.queryParams.subscribe(params => {
      this.categoryId = +params['categoryId'];
    });

      
   }

    // ngOnDestroy(): void {
    //     localStorage.removeItem('mobile_number');
    // }

  toggleSection(section: string) {
    if (this.openSection === section) {
      this.openSection = '';
    } else {
      this.openSection = section;

      setTimeout(() => {
        if (section === 'text') {
          this.scroller.scrollToAnchor('divNote');

        } else if (section === 'document') {
          this.scroller.scrollToAnchor('divSelfie');
        }
      }, 100);
    }
  }

  togglestep(section: string) {
    if (this.openSection === section) {
      this.openSection = '';
      this.currentStep = null;
    } else {
      this.openSection = section;
      this.currentStep = 'step1'; // Start form

      setTimeout(() => {
        if (section === 'text') {
          this.scroller.scrollToAnchor('divNote');
        } else if (section === 'document') {
          this.scroller.scrollToAnchor('divSelfie');
        }
      }, 100);
    }
  }


  uploadFromFolder(event: any) {
    this.documentFile = null;
    const file = event.target.files[0];

    if (!file) return;

    // Check if it's a video
    if (!file.type.startsWith('video/')) {
      alert('Please upload a valid video file.');
      return;
    }

    // Limit size to 500MB
    const maxSizeInMB = 500;
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

    if (file.size > maxSizeInBytes) {
      alert('Maximum file size of 500 MB is not allowed.');
      event.target.value = '';
      this.documentFile = null;
      return;
    }

     this.documentFile = file;
    console.log('Video file accepted:', file);
  }

  fetchVoucherCategories(): void {
    this.categoryService.getCategoryList().subscribe(response => {
      this.voucherCategories = response.response.data;

      // Automatically select first category as default
      if (this.voucherCategories?.length) {
        this.defaultCategoryId = this.voucherCategories[0].id; // adjust field name if different
      }
    });
  }

  redirectToVoucherPage(categoryId: number): void {
    this.router.navigate(['/giftvoucher'], { queryParams: { categoryId } });
  }

  // Text Upload
  uploadText(): void {
    const userCode = JSON.parse(this.profileData).user_code;
    // const categoryId = this.defaultCategoryId;

    this.categoryService.checkOfferRedemption(userCode, this.token).subscribe((response:any) => {
    console.log('Offer redemption response:', response);
      if (response.response.status === 1) {
        alert(response.response.msg);
      } else if (response.response.status === 0) {
        const formData = new FormData();
        formData.append('button_name', 'Text Upload');
        formData.append('text_input', this.textInput);

        if (this.documentFile) {
          formData.append('document_file', this.documentFile);
        }

        formData.append('no_option_field', this.noOptionField);
        formData.append('user_code', userCode);
        formData.append('is_active', '1');
        formData.append('token', this.token);

        this.categoryService.insertUserAction(formData).subscribe(response => {
          console.log('Text upload response:', response);
          alert('Note Saved!');

          if (this.defaultCategoryId) {
            this.redirectToVoucherPage(this.defaultCategoryId);
          } else {
            console.error('No category ID found to redirect');
          }
        });
      }
    }, error => {
      console.error('Error checking offer redemption:', error);
      alert('Error checking offer redemption. Please try again.');
    });
  }

  // uploadText(): void {
  //   const userCode = JSON.parse(this.profileData).user_code;
  //   const formData = new FormData();
  //   formData.append('button_name', 'Text Upload');
  //   formData.append('text_input', this.textInput);
  //   if (this.documentFile) {
  //     formData.append('document_file', this.documentFile);
  //   }
  //   formData.append('no_option_field', this.noOptionField);
  //   formData.append('user_code', userCode);
  //   formData.append('is_active', '1');
  //   formData.append('token', this.token);

  //   this.categoryService.insertUserAction(formData).subscribe(response => {
  //     console.log('Text upload response:', response);
  //     alert('Text uploaded successfully!');

  //     if (this.defaultCategoryId) {
  //       this.redirectToVoucherPage(this.defaultCategoryId);
  //     } else {
  //       console.error('No category ID found to redirect');
  //     }
  //   });
// }

  // Document Upload
  uploadDocument(): void {
    if (!this.documentFile) {
      alert('No valid video file selected.');
      return;
    }

    const maxSizeInBytes = 500 * 1024 * 1024;
    if (this.documentFile.size > maxSizeInBytes) {
      alert('File size exceeds the maximum limit of 500 MB.');
      return;
    }

    this.isUploading = true;
    const userCode = JSON.parse(this.profileData).user_code;

    if (this.documentFile) {
      const formData = new FormData();
      formData.append('video_file', this.documentFile);
      formData.append('button_name', 'Video File');
      formData.append('no_option_field', this.noOptionField);
      formData.append('user_code', userCode);
      formData.append('is_active', '1');
      formData.append('token', this.token);

      this.categoryService.insertUserAction(formData).subscribe(response => {
        console.log('Document upload response:', response);
        alert('Your video has been successfully Captured!');
         this.isUploading = false;

        if (this.defaultCategoryId) {
          this.redirectToVoucherPage(this.defaultCategoryId);
        } else {

          console.error('No category ID found to redirect');
           this.isUploading = false;
        }
      });
    }
  }

  // Redirect Action
  redirectAction(): void {
    const userCode = JSON.parse(this.profileData).user_code;
    const formData = new FormData();
    formData.append('button_name', 'Redirect Action');
    formData.append('text_input', '');
    formData.append('document_file', '');
    formData.append('no_option_field', this.noOptionField);
    formData.append('user_code', userCode);
    formData.append('is_active', '1');
    formData.append('token', this.token);

    this.categoryService.insertUserAction(formData).subscribe(response => {
      console.log('Redirect response:', response);
      if (this.defaultCategoryId) {
        this.redirectToVoucherPage(this.defaultCategoryId);
      } else {
        console.error('No category ID found to redirect');
      }
    });
  }

  filterNumberOnly(value: string) {
    const cleaned = value.replace(/[^0-9]/g, '').substring(0, 10);
    this.mobileNumber = cleaned;
  }

  setFocusToMobile(): void {
    setTimeout(() => {
      const input = document.getElementById('mobileInput');
      if (input) {
        input.focus();
      }
    }, 100);
  }



  verifyMobile() {

    if (!/^\d{10}$/.test(this.mobileNumber)) {
      alert('Please enter a valid 10-digit mobile number.');
      this.mobileVerified = false;
      this.setFocusToMobile();
      return;
    }

    if (!this.mobileNumber) {
      alert('Please enter mobile number');
      this.mobileVerified = false;
      this.setFocusToMobile();
      return;
    }

    this.categoryService.validateMobileNumber(this.mobileNumber, this.token).subscribe(
      (response: any) => {
        // console.log('Mobile Number Validation:', response);

        if (response.response.status === 1) {
          alert('Seems like this Architect is already registered with CenturyJoy. Please refer someone else.');
          this.mobileVerified = false;
          this.setFocusToMobile();
          return;
        }

        this.categoryService.referrerdetails_mobile(this.token, this.mobileNumber).subscribe(
          (secondResponse: any) => {
            // console.log('Referrer Details Mobile Validation:', secondResponse);

            if (secondResponse.response.status === 1) {
              alert('Seems like this Architect is already registered with CenturyJoy. Please refer someone else.');
              this.mobileVerified = false;
              this.setFocusToMobile();
              return;
            }

            // alert('This mobile number is not registered in any system.');
            this.mobileVerified = true;
            this.currentStep = 'step2';
          },
          (error) => {
            console.error('Error during second call:', error);
            alert('Something went wrong while verifying with the Mobile Number.');
            this.mobileVerified = false;
            this.setFocusToMobile();
          }
        );
      },
      (error) => {
        console.error('Error during first call:', error);
        alert('Something went wrong during mobile number verification.');
        this.mobileVerified = false;
        this.setFocusToMobile();
      }
    );
  }



  // verifyMobile() {
  //   if (this.mobileNumber) {

  //     this.categoryService.validateMobileNumber(this.mobileNumber, this.token).subscribe((response: any) => {
  //       console.log('Mobile Number Validation:', response);
  //       if (response.response.status === 1) {
  //         alert('Oops. This AID already exists in the CenturyJoy Program. Try another.');
  //         // alert(response.response.msg);
  //       } else {
  //         alert('This mobile number is not registered in any system.');
  //         this.currentStep = 'step2';
  //         // this.router.navigate(['/events']);
  //       }
  //     },
  //     (error) => {
  //       console.error('API error:', error);
  //       alert('Something went wrong during mobile verification.');
  //     });
  //   } else {
  //     alert('Please enter mobile number');
  //   }
  // }

  allowOnlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    const charStr = String.fromCharCode(charCode);

    if (!/^[0-9]+$/.test(charStr)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  allowAlphaNumeric(event: KeyboardEvent) {
    const allowedRegex = /^[a-zA-Z0-9 ]*$/;
    const inputChar = String.fromCharCode(event.keyCode);

    if (!allowedRegex.test(inputChar)) {
      event.preventDefault();
    }
  }

  validateFirmDetails() {
    if (this.firm_name && this.refName) {
      this.categoryService.validateFirmDetails(this.token, this.firm_name, this.refName, this.city)
        .subscribe((response: any) => {
          if (response.response.status === 0) {
            alert(response.response.msg);
            this.firmDetailsValid = true;
          } else {
            alert('The AID under this firm name already exists in our system');
            this.firmDetailsValid = false;
          }
        }, error => {
          console.error('Validation error:', error);
          alert('Error validating firm details.');
        });
    } else {
      alert('Please fill required fields.');
    }
  }

  public redirectToIndex() {
    this.router.navigate(['/index'], { replaceUrl: true });
  }



  submitFirmDetails() {
    if (!this.firm_name || !this.refName || !this.selectedCity) {
      alert('Please fill required fields.');
      return;
    }

    const userCode = JSON.parse(this.profileData).user_code;

    //monthly referral limit
    this.categoryService.checkOfferRedemption(userCode, this.token).subscribe((offerResponse: any) => {
      const msg = offerResponse.response.msg;
      const status = offerResponse.response.status;

      if (
        status === 1 &&
        msg === "Looks like you've used up this month's referrals. Don't worry — you can try again next month!"
      ) {
        alert(msg);
        this.redirectToIndex();
        return;
      }

      //check if architect already registered
      this.categoryService.referrerdetails_mobile(this.token, this.mobileNumber).subscribe(
        (response: any) => {
          if (response.response.status === 1) {
            alert('Seems like this Architect is already registered with CenturyJoy. Please refer someone else.');
            this.mobileVerified = false;
            this.setFocusToMobile();
            return;
          }

          //Validate firm details
          this.categoryService.validateFirmDetails(this.token, this.firm_name, this.refName, this.city)
            .subscribe((validationRes: any) => {
              if (validationRes.response.status === 0) {

                this.categoryService.referrerdetails(this.token,userCode,this.mobileNumber,this.refName,this.firm_name,this.selectedCity,this.selectedState?.state_id
                ).subscribe((response: any) => {
                  if (response.response.status === 1) {

                    const formData = new FormData();
                    formData.append('button_name', 'Refer & Win');
                    formData.append('user_code', userCode);
                    formData.append('is_active', '1');
                    formData.append('token', this.token);

                    this.categoryService.insertUserAction(formData).subscribe(actionResponse => {
                      alert('Your referral has been accepted. Please choose your voucher.');
                      localStorage.setItem('mobile_number', this.mobileNumber);
                      if (this.defaultCategoryId) {
                        this.redirectToVoucherPage(this.defaultCategoryId);
                      } else {
                        console.error('No category ID found to redirect');
                      }
                    }, error => {
                      console.error('User action failed:', error);
                      alert('Firm submitted, but logging failed.');
                    });
                  } else {
                    alert('The AID under this firm name already exists in our system.');
                  }
                }, error => {
                  console.error('Firm submission error:', error);
                  alert('Something went wrong while submitting firm details.');
                });
              } else {
                alert('The AID under this firm name already exists in our system.');
              }
            }, error => {
              console.error('Validation error:', error);
              alert('Something went wrong while validating firm details.');
            });
        }, error => {
          console.error('referrerdetails_mobile API error:', error);
          alert('Something went wrong while checking mobile number.');
        });

    }, error => {
      console.error('checkOfferRedemption error:', error);
      alert('Something went wrong while checking referral status.');
    });
  }



  // submitFirmDetails() {
  //   const userCode = JSON.parse(this.profileData).user_code;

  //   this.categoryService.referrerdetails(this.token,userCode,this.mobileNumber,this.refName,this.firm_name,this.selectedCity,this.selectedState).subscribe((response: any) => {

  //     if (response.response.status === 1) {
  //       console.log('Firm details submitted successfully.');

  //       const formData = new FormData();
  //       formData.append('button_name', 'Refer & Win');
  //       formData.append('user_code', userCode);
  //       formData.append('is_active', '1');
  //       formData.append('token', this.token);

  //       this.categoryService.insertUserAction(formData).subscribe(actionResponse => {
  //         console.log('User action logged:', actionResponse);

  //         alert('Your referral has been accepted. Please choose your voucher.');

  //         if (this.defaultCategoryId) {
  //           this.redirectToVoucherPage(this.defaultCategoryId);
  //         } else {
  //           console.error('No category ID found to redirect');
  //         }

  //       }, error => {
  //         console.error('User action failed:', error);
  //         // alert('Data saved, but logging failed.');
  //       });

  //     } else {
  //       alert('The AID under this firm name already exists in our system.');
  //     }

  //   }, error => {
  //     console.error('Submit error:', error);
  //     alert('Something went wrong while submitting firm details.');
  //   });
  // }


  // submitFirmDetails() {
  //   const userCode = JSON.parse(this.profileData).user_code;
  //   this.categoryService.referrerdetails(this.token, userCode, this.mobileNumber,this.refName, this.firm_name, this.selectedCity, this.selectedState)
  //     .subscribe((response: any) => {
  //       if (response.response.status === 1) {
  //         alert('Data submission successfull!');
  //         if (this.defaultCategoryId) {
  //           this.redirectToVoucherPage(this.defaultCategoryId);
  //         } else {
  //           console.error('No category ID found to redirect');
  //         }
  //       } else {
  //         alert('Failed to save data: ' + response.response.msg);
  //       }
  //     }, error => {
  //       console.error('Submit error:', error);
  //       alert('Something went wrong while submitting data.');
  //     });
  // }

  // Fetch states and cities from the API
  getStatesAndCities(): void {
    this.categoryService.getStateCity(this.token).subscribe(response => {
      if (response.response.status === 1) {
        this.statesAndCities = response.response.data;
        console.log(this.statesAndCities);
        this.dropdownoptionState=this.statesAndCities.map((item:any)=>({
          state_id:item.StateID,state_name:item.StateName
        }))
      } else {
        console.error('Error:', response.response.msg);
      }
    }, error => {
      console.error('Error:', error);
    });
  }

  onStateChange(event: any): void {
    this.selectedState = event.value;

    const stateData = this.statesAndCities.find(state => state.StateID === event.value.state_id);
    if (stateData) {
      this.cities = stateData.cities;
      this.dropdownoptionCity=this.cities.map((item:any)=>({
        city_id:item.CityID,city_name:item.CityName
      }))
      this.selectedCity = this.cities[0]?.CityID || 0;
    }
  }

StatedropdownConfig = {
  displayKey: "state_name",
  search: true,
  height: '200px',
  placeholder: 'Select State',
  customComparator: undefined,
  limitTo: 0,
  moreText: 'more',
  noResultsFound: 'No results found!',
  searchPlaceholder: 'Search State',
  searchOnKey: 'state_name'
};

CityropdownConfig = {
  displayKey: "city_name",
  search: true,
  height: '200px',
  placeholder: 'Select City',
  customComparator: undefined,
  limitTo: 0,
  moreText: 'more',
  noResultsFound: 'No results found!',
  searchPlaceholder: 'Search City',
  searchOnKey: 'city_name'
};

}
